import Api from './applications';
import { getFileURL } from './storage/s3';

/**
 * Tenant profile service — backed by the dedicated profile API (GET/PUT /profile/my).
 * Each tenant has one universal profile not tied to any specific apartment.
 * The tenant radar consent lives on the profile and the backend syncs it to the
 * tenant's linked applications, which is what the radar lists.
 */

const getOwnProfile = async (_userId: string): Promise<any> => {
    const profile = await Api.getMyProfile();

    const data = { ...(profile || {}) };
    if (data.profilePictureKey) {
        data.profilePicture = await getFileURL(data.profilePictureKey);
    }

    return {
        userId: _userId,
        isActive: profile?.contactInformationConsent === true,
        data,
        identityVerified: false,
        bankDataVerified: false,
    };
};

const saveProfile = async (_userId: string, data: any): Promise<any> => {
    // profilePicture (Blob/URL) is handled by the saga — saga uploads to S3 and sets profilePictureKey
    const { profilePicture, ...profileData } = data;
    await Api.updateMyProfile(profileData);
    return getOwnProfile(_userId);
};

const setRadarConsent = async (consent: boolean): Promise<{ isActive: boolean }> => {
    await Api.updateMyProfile({ contactInformationConsent: consent });
    return { isActive: consent };
};

export default {
    getOwnProfile,
    saveProfile,
    setRadarConsent
};
